import { Box, Divider, Grid, GridItem, Spinner, Stack, Text, } from "@chakra-ui/react";
import { capitalize } from "lodash";
import React, { useEffect, useState } from "react";
import { WeatherWidgetIcon } from "../../components/WeatherIcon";
import { weatherBackgroundColorGradients } from "../../utils/style";
import { ImLocation } from "react-icons/im";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { formatWeatherApiData, formatWeatherTemp } from "../../utils/functions";
import { weatherFetchUrl } from "../../utils/weatherQueries";
import { useFetch } from "../../hooks/useFetch";
import { getWidgetWidth } from "@govisupro/controls";
export const PreviewPlayer = ({ layoutItem, screenWidth, }) => {
    var _a;
    const [weather, setWeather] = useState();
    const weatherData = layoutItem.widget.data;
    const widgetWidth = getWidgetWidth({
        layoutItemWidth: layoutItem.width,
        screenWidth,
        scale: (_a = layoutItem.scale) !== null && _a !== void 0 ? _a : 1,
    });
    const fetchUrl = weatherFetchUrl({
        selectedCity: weatherData.city,
        weatherType: weatherData.type,
    });
    const { data, loading } = useFetch(fetchUrl);
    useEffect(() => {
        if (!data)
            return;
        setWeather(formatWeatherApiData(data, weatherData.type));
    }, [data]);
    return (React.createElement(Stack, null, weather && !loading ? (React.createElement(WeatherDisplay, { weatherData: weatherData, widgetWidth: widgetWidth !== null && widgetWidth !== void 0 ? widgetWidth : 0, weather: weather })) : (React.createElement(Spinner, null))));
};
export const WeatherDisplay = ({ weatherData, widgetWidth, weather, }) => {
    var _a, _b, _c;
    const actualWeatherType = Array.isArray(weather === null || weather === void 0 ? void 0 : weather.weather)
        ? (weather === null || weather === void 0 ? void 0 : weather.weather.length) === 5
            ? "daily"
            : "hourly"
        : "current";
    switch (true) {
        case actualWeatherType === "current":
            return (React.createElement(WeatherWidget
            // @ts-ignore
            , { 
                // @ts-ignore
                weatherData: Object.assign(Object.assign({}, weatherData), { weather: weather }), widgetWidth: widgetWidth }));
        case actualWeatherType === "daily":
            return (React.createElement(Grid, { gridTemplateColumns: "repeat(2, 1fr)", gridGap: `calc(${(_a = weatherData.gridGap) !== null && _a !== void 0 ? _a : 2} * 0.25rem)`, width: widgetWidth }, 
            //@ts-ignore
            weather.weather.map((item, index) => {
                var _a;
                return (React.createElement(GridItem, { colSpan: index === 0 ? 2 : 1, key: index },
                    React.createElement(WeatherWidget, { weatherData: Object.assign(Object.assign({}, weatherData), { weather: Object.assign(Object.assign({}, weather), { weather: item }) }), widgetWidth: index === 0
                            ? widgetWidth
                            : widgetWidth / 2 -
                                (((_a = weatherData.gridGap) !== null && _a !== void 0 ? _a : 2) * (0.25 * 16)) / 2, displayMinAndMax: true, dateText: index === 0
                            ? "Ajourd'hui"
                            : index === 1
                                ? "Demain"
                                : undefined })));
            })));
        case actualWeatherType === "hourly":
            return (React.createElement(Grid, { gridTemplateColumns: `repeat(${(_b = weatherData.gridColumns) !== null && _b !== void 0 ? _b : 2}, 1fr)`, gridGap: `calc(${(_c = weatherData.gridGap) !== null && _c !== void 0 ? _c : 2} * 0.25rem)`, width: widgetWidth }, 
            //@ts-ignore
            weather.weather.map((item, i) => {
                var _a, _b, _c, _d;
                return (React.createElement(GridItem, { key: i },
                    React.createElement(WeatherWidget, { weatherData: Object.assign(Object.assign({}, weatherData), { weather: Object.assign(Object.assign({}, weather), { weather: item }) }), widgetWidth: widgetWidth / ((_a = weatherData.gridColumns) !== null && _a !== void 0 ? _a : 2) -
                            (((_b = weatherData.gridGap) !== null && _b !== void 0 ? _b : 2) /
                                ((_c = weatherData.gridColumns) !== null && _c !== void 0 ? _c : 2)) *
                                0.25 *
                                16 *
                                (((_d = weatherData.gridColumns) !== null && _d !== void 0 ? _d : 2) - 1), displayHour: true })));
            })));
        default:
            return React.createElement(React.Fragment, null);
    }
};
const WeatherWidget = ({ weatherData, widgetWidth, displayMinAndMax = false, displayHour = false, dateText, }) => {
    const weather = weatherData.weather;
    console.log(dateText);
    return (React.createElement(Stack, { p: `${widgetWidth / 21}px`, borderRadius: `${widgetWidth / 35}px`, position: "relative", overflow: "hidden", justifyContent: "center", width: `${widgetWidth}px`, gap: `${widgetWidth / 40}px`, fontFamily: weatherData.theme === "custom" ? weatherData.font : "inherit", fontWeight: weatherData.theme === "custom" ? weatherData.weight : 400, color: weatherData.theme === "custom" ? weatherData.textColor : "white", bgGradient: weatherData.theme === "default"
            ? `linear(to-r, ${weatherBackgroundColorGradients[weather.weather.icon].start}, ${weatherBackgroundColorGradients[weather.weather.icon].end})`
            : `linear(to-r, ${weatherData.backgroundColor.type === "color"
                ? weatherData.backgroundColor.color
                : weatherData.backgroundColor.gradient.start}, ${weatherData.backgroundColor.type === "color"
                ? weatherData.backgroundColor.color
                : weatherData.backgroundColor.gradient.end})` },
        React.createElement(Text, { fontSize: `${widgetWidth / 26}px`, lineHeight: "90%" },
            capitalize(weather.weather.description),
            React.createElement(Text, { as: "span" }, displayHour
                ? ` - ${weather.weather.date.toLocaleString([], {
                    timeStyle: "short",
                })}`
                : "")),
        React.createElement(Stack, { direction: "row", gap: `${widgetWidth / 50}px`, alignItems: "center", mt: "0 !important" },
            displayMinAndMax ? (React.createElement(Stack, { gap: `${widgetWidth / 50}px`, alignItems: "center" },
                React.createElement(Text, { fontSize: `${widgetWidth / 30}px`, lineHeight: "90%", display: "flex", alignItems: "center", gap: `${widgetWidth / 75}px` },
                    React.createElement(Text, { as: "span" },
                        React.createElement(BsArrowUp, null)),
                    formatWeatherTemp({
                        temp: weather.weather.temp_min,
                        unit: weatherData.unit,
                    })),
                React.createElement(Text, { fontSize: `${widgetWidth / 30}px`, lineHeight: "90%", mt: "0 !important", display: "flex", alignItems: "center", gap: `${widgetWidth / 75}px` },
                    formatWeatherTemp({
                        temp: weather.weather.temp_max,
                        unit: weatherData.unit,
                    }),
                    React.createElement(Text, { as: "span" },
                        React.createElement(BsArrowDown, null))))) : (React.createElement(Text, { fontSize: `${widgetWidth / 10}px`, lineHeight: "90%" }, formatWeatherTemp({
                temp: weather.weather.temp,
                unit: weatherData.unit,
            }))),
            widgetWidth > 200 ? (React.createElement(Box, { h: "70%" },
                React.createElement(Divider, { orientation: "vertical", borderColor: weatherData.theme === "custom" ? weatherData.textColor : "white", opacity: "0.6" }))) : (React.createElement(React.Fragment, null)),
            React.createElement(Stack, { justifyContent: "center", gap: `${widgetWidth / 50}px`, marginInlineStart: "0.3rem !important" },
                React.createElement(Text, { fontSize: `${widgetWidth / 26}px`, lineHeight: "100%", display: "flex", alignItems: "center", gap: `${widgetWidth / 62}px` },
                    React.createElement(ImLocation, { fontSize: `${widgetWidth / 40}px` }),
                    `${weather.city.name}, ${weather.city.country}`),
                React.createElement(Text, { fontSize: `${widgetWidth / 26}px`, lineHeight: "100%", marginTop: "0 !important" }, dateText !== null && dateText !== void 0 ? dateText : weather.weather.date.toLocaleString([], {
                    dateStyle: "long",
                }))),
            React.createElement(Box, { position: "absolute", top: "0", right: "0", display: "flex", alignItems: "center", height: "100%", sx: { aspectRatio: "1/1", "> *": { width: "100%" } }, p: `${widgetWidth / 21}px` }, WeatherWidgetIcon[weather.weather.icon]))));
};
